//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import {
    agreementInfo,
    agreementInfoSubmit,
    userInfo
  } from './service/index'
  import {
    getCookie
  } from './utils/storage'
  import {
    mapState,
    mapMutations,
    mapActions
  } from 'vuex'
  import watermark from '@/components/watermark.vue'
  import {
    setTimeout
  } from 'timers';
  let Base64 = require('js-base64').Base64;
  const bodyScrollLock = require('body-scroll-lock');
  const disableBodyScroll = bodyScrollLock.disableBodyScroll;
  const enableBodyScroll = bodyScrollLock.enableBodyScroll;
  const targetElement = document.querySelector("#modal");
  const agreementElement = document.querySelector("#agreement-modal");

  export default {
    name: 'App',
    data() {
      return {
        refreshPage: false
      }
    },
    components: {
      watermark
    },
    mounted() {
      //this.tempName = Base64.decode(getCookie("user_name"));
      this.setTempName(Base64.decode(getCookie("user_name")))
    },
    watch: {
      'global.showAgreement': function (val) {
        if (val == true) {
          disableBodyScroll(agreementElement);
        } else {

        }
      }
    },

    computed: {
      ...mapState([
        "global", "rule", "tempName", "agreement_loading"
      ]),

    },
    methods: {
      ...mapActions(['showRule']),
      async closeAgreement() {
        let cid = !!this.$route.query.cid ? this.$route.query.cid : -1
        //this.toggleAgreement(false)
        const res = await agreementInfoSubmit(cid);
        enableBodyScroll(agreementElement);

        if (res.status === 0) {
          // this.refreshPage = true
          // this.showRule(this.$route.query.cid)
          window.location.reload()
          this.toggleAgreement(false)
        }
      },
      closeAgreementDirect() {
        this.toggleAgreement(false)
      },
      closeRule() {
        this.hideRule()
        enableBodyScroll(targetElement);

        if (this.refreshPage) {
          window.location.reload()
        }
      },
      ...mapMutations({
        toggleAgreement: 'TOGGLE_AGREEMENT',
        hideRule: 'HIDE_RULE',
        setTempName: 'SET_TEMPNAME'
      })
    }

  }




// WEBPACK FOOTER //
// ./src/App.vue